import { FONT_FAMILY } from 'styles/typography'
import { hexToRgba } from 'styles/theme.js'

const themeStyles = colors => {
  const defaultStyles = {
    quickActionArea: {
      width: '100%',
      fontFamily: FONT_FAMILY
    },
    quickActionImg: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'baseline',
      height: '100%'
    },
    barTitle: {
      fontSize: '18px',
      fontWeight: '700',
      color: colors.approxBlack
    },
    container: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignContent: 'center',
      justifyContent: 'space-evenly',
      alignItems: 'center',
      width: '100%',
      height: '130px',
      margin: '14px 0',
      borderRadius: '4px',
      background: colors.white,
      boxShadow: `0px 3px 7px 0px ${hexToRgba(colors.white, 0.6)}`,
      padding: '0 5%'
    },
    noPadding: {
      padding: '10 0',
      height: 'auto'
    },
    quickActionItem: {
      textAlign: 'center',
      cursor: 'pointer',
      background: 'none',
      border: 'none',
      margin: '10px 0'
    },
    quickActionItemText: isMobile => {
      return {
        display: 'flex',
        alignItems: isMobile ? 'center' : 'flex-start',
        fontSize: '14px',
        fontWeight: '500',
        maxHeight: 65,
        paddingTop: !isMobile && 5,
        color: colors.primary
      }
    },
    images: {
      width: 32,
      height: 'auto',
      fill: colors.iconGrey
    },
    actionItemWithMarginBottom: {
      marginBottom: '10px',
      width: 32,
      height: 'auto'
    },
    actionItem: {
      width: 32,
      height: 'auto'
    },
    row: (isMobile) => ({
      justifyContent: isMobile ? 'flex-start' : 'center'
    })
  }
  return defaultStyles
}

export default themeStyles
